webpackJsonp([219723240421529],{

/***/ 312:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"relativePath":"GDK>src/pages/sales.js"}}

/***/ })

});


// WEBPACK FOOTER //
// path---contactus-d33e4aa8d86fbcb4165e.js